<template>
  <form @submit.prevent="submit">
    <dt-modal
      v-model="isVisible"
      :modalSize="modalSize"
    >
      <div slot="header">
        <h4 class="modal-title">
          Visitations
        </h4>
      </div>
      <div slot="body">
        <div class="row">
          <contact-drives :contact="value" />
        </div>
      </div>
      <div slot="footer">
        <button
          type="button"
          class="btn btn-light"
          @click="close()"
        >Okay</button>
      </div>
    </dt-modal>
  </form>
</template>
<script>
import DtModal from '@/components/utilities/modal/dt-modal.vue'
import ContactDrives from '@/components/contacts/listings/contact-drives.vue'
export default {
  name: 'contact-drives-dialog',
  components: {
    DtModal,
    ContactDrives
  },
  props: {
    value: {
      type: Number
    }
  },
  data() {
    return {
      modalSize: 'modal-xl'
    }
  },
  computed: {
    isVisible: {
      get() {
        return this.value !== null
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    close() {
      this.$emit('closing')
    },
    submit() {
      this.$emit('send')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/contacts/forms/contact-drives-dialog.vue